export const withBFFApiKeyHeader = () => {
  const xApiKey = process.env.AIP_BFF_X_API_KEY;
  if (!xApiKey) {
    throw new Error('Missing env: AIP_BFF_X_API_KEY');
  }

  return {
    'x-api-key': xApiKey,
  };
};
